import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiCall } from "../lib/apiClient";

/**
 * tenantAdmin self-service: všechny karty střediska + držitelé + přiřazení.
 * Vše tenant-scoped (princip #6); číslo karty maskované (princip #1).
 */

export interface TenantCard {
  fuel_card_id: string;
  card_label: string | null;
  card_number_display: string | null;
  status: string;
  network: string | null;
  expiry_date: string | null;
  holder_id: string | null;
  holder_label: string | null;
  holder_type: string | null;
  active: boolean;
}

export interface TenantCardsResponse {
  cards: TenantCard[];
}

export interface TenantHolder {
  id: string;
  holder_type: string;
  display_name: string;
  user_id: string | null;
  ico: string | null;
  deactivated_at: string | null;
}

export interface TenantHoldersResponse {
  rows: TenantHolder[];
}

const KEY_CARDS = ["tenant", "cards"] as const;
const KEY_HOLDERS = ["tenant", "holders"] as const;

export function useTenantCards() {
  return useQuery({
    queryKey: KEY_CARDS,
    queryFn: () => apiCall<TenantCardsResponse>("/api/tenant/cards"),
    staleTime: 60_000,
  });
}

export function useTenantHolders() {
  return useQuery({
    queryKey: KEY_HOLDERS,
    queryFn: () => apiCall<TenantHoldersResponse>("/api/tenant/holders"),
    staleTime: 60_000,
  });
}

export function useAssignCardHolder() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: ({ fuelCardId, holderId }: { fuelCardId: string; holderId: string | null }) =>
      apiCall(`/api/tenant/cards/${fuelCardId}/holder`, {
        method: "PUT",
        body: JSON.stringify({ holder_id: holderId }),
      }),
    onSuccess: () => {
      void client.invalidateQueries({ queryKey: KEY_CARDS });
    },
  });
}
